<div class="shadow_spinner" *ngIf="show">
    <mat-spinner diameter="80" color="blue" class="d-flex justify-content-center align-items-center"></mat-spinner>
</div>